export const INVALID_CONTACT_MESSAGE = 'Please enter a valid mobile number or email address.';
export const INVALID_PHONE_MESSAGE = 'Please enter a valid mobile number.';
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address.';
